import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import Avatar from "./Avatar";
import VerifiedBadge from "./VerifiedBadge";
import { useAuth } from "../context/AuthContext";

export default function SuggestedPlayers() {
  const { user } = useAuth();
  const [players, setPlayers] = useState([]);

  useEffect(() => {
    if (!user) return;
    api.get("/suggested?limit=5").then(({ data }) => setPlayers(data));
  }, [user]);

  const follow = async (id) => {
    await api.post(`/users/${id}/follow`);
    setPlayers((p) => p.filter((u) => u.id !== id));
  };

  if (!user) return null;

  return (
    <aside data-testid="suggested-sidebar" className="bg-[#121212] border border-[#262626] rounded-sm">
      <div className="px-4 py-3 border-b border-[#262626]">
        <h3 className="font-display text-sm tracking-widest uppercase text-white">Players to follow</h3>
      </div>
      <ul className="divide-y divide-[#262626]">
        {players.length === 0 && (
          <li className="p-4 text-xs text-[#737373]">No suggestions right now.</li>
        )}
        {players.map((p) => (
          <li key={p.id} className="p-4 flex items-center gap-3">
            <Link to={`/profile/${p.id}`}>
              <Avatar url={p.avatar_url} name={p.name} size={40} />
            </Link>
            <div className="flex-1 min-w-0">
              <Link to={`/profile/${p.id}`} className="block text-sm text-white font-semibold truncate hover:underline">
                {p.name} <VerifiedBadge role={p.role} verified={p.verified} size={12} />
              </Link>
              <div className="text-xs text-[#a3a3a3] truncate">
                {p.position || "Player"}{p.team ? ` · ${p.team}` : ""}
              </div>
            </div>
            <button
              data-testid={`suggested-follow-${p.id}`}
              onClick={() => follow(p.id)}
              className="text-xs px-3 py-1.5 border border-[#404040] text-white hover:bg-[#1a1a1a] rounded-sm transition-colors"
            >
              Follow
            </button>
          </li>
        ))}
      </ul>
    </aside>
  );
}
